import { baseApi } from './baseApi'
import { ICheckoutData, IOrderFormParams } from '../../types/app'
import { IOrderResponse, IPaginatedOrdersResponse } from '../../types/orders'

export interface IGetOrdersParams {
  page?: number
  limit?: number
}

export const ordersApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    checkout: builder.mutation<void, ICheckoutData>({
      query: (data) => ({
        url: '/order/send-message',
        method: 'POST',
        body: data,
        // Accept older servers' text responses as well as JSON during rollout.
        responseHandler: 'content-type',
      }),
      invalidatesTags: ['Orders'],
    }),
    getOrders: builder.query<IPaginatedOrdersResponse, IGetOrdersParams>({
      query: ({ page = 1, limit = 10 } = {}) =>
        `/order/orders?page=${page}&limit=${limit}`,
      providesTags: ['Orders'],
    }),
    deleteOrder: builder.mutation<void, string>({
      query: (orderId) => ({
        url: `/order/orders/${orderId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Orders'],
    }),
    editOrder: builder.mutation<
      void,
      { params: Partial<IOrderFormParams>; orderId: string }
    >({
      query: ({ params, orderId }) => ({
        url: `/order/orders/${orderId}`,
        method: 'PUT',
        body: params,
      }),
      invalidatesTags: ['Orders'],
    }),
    createOrder: builder.mutation<void, IOrderFormParams>({
      query: (params) => ({
        url: '/order/orders',
        method: 'POST',
        body: params,
      }),
      invalidatesTags: ['Orders'],
    }),
  }),
})

export const {
  useCheckoutMutation,
  useGetOrdersQuery,
  useDeleteOrderMutation,
  useEditOrderMutation,
  useCreateOrderMutation,
} = ordersApi
